$('.abz-slidehow .vertical-slider').slick({
  dots: true,
  arrows:false,
  draggable: true,
  touchMove: true,
  vertical: true,
  verticalSwiping: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  adaptiveHeight: false,
  infinite: true
});
$('.abz-announcementbar .regular').slick({
  arrows: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 8000
});


$('.popular-products__filters li').each(function(i) {
    $(this).attr('id', 'tab'+(i+1));
});



// Active first tab
$("#tab1 .filters__item:nth-child(1)").addClass("filters__item_active");



const h1 = document.getElementsByClassName('collection-hero__title');

for (let x = 0; x < divs.length; x++) {
    const div = divs[x];
    const content = div.textContent.trim();

    if (content == '- Education' || content == 'Thuis') {
        div.style.display = 'none';
    }
}
